import axios, { AxiosRequestConfig } from 'axios';
import { join } from 'urlcat';

import oauth from '@/plugins/oauth';

import { API_URL as apiURL } from '@/config/xsolla';

function validateStatus(status: number) {
  return status >= 200 && status < 400;
}

function beforeRequest(config: AxiosRequestConfig) {
  const { accessToken } = oauth.authState;

  Object.assign(config.headers, {
    Authorization: `Bearer ${accessToken}`,
  });

  return config;
}

function errorRequest(error: unknown) {
  return Promise.reject(error);
}

const createClient = function(path: string) {
  const config = {
    validateStatus,
    baseURL: join(apiURL as string, '/', path),
  };

  const client = axios.create({ ...config });

  client.interceptors.request.use(beforeRequest, errorRequest);

  return client;
};

export default createClient;

export * from './config';
